var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-button-group',{attrs:{"data":_vm.d},on:{"click":_vm.clcked}})}
var staticRenderFns = []

export { render, staticRenderFns }